import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { Loading } from 'mailup-web-components'
import Header from './components/Header'

import {
  initCallback,
  initPreviewsCallback
} from './recoil/callbacks/callbacks'
import ErrorFeedback from 'Components/ErrorFeedback'
import { pageState } from './recoil/state/page'
import { errorState } from 'Recoil/state/errorState'
import BoxGoToPreview from './components/BoxGoToPreview'
import BoxOnScreen from './components/BoxOnScreen'
import { BASIC_VIEW, FULL_VIEW, QUICK_VIEW } from './const'
import QuickFullPreview from 'Pages/EmailMessagePreview/components/QuickFullPreview/QuickFullPreview'
import PreviewModal from 'Pages/EmailMessagePreview/components/PreviewModal/PreviewModal'
import PageContainer from 'Components/PageContainer'

const EmailMessagePreview = () => {
  const { id } = useParams()
  const { loading, error: pageError, loaded, severity, view } = useRecoilValue(
    pageState
  )
  const { error: globalError } = useRecoilValue(errorState)
  const init = useRecoilCallback(initCallback, [])
  const initPreviews = useRecoilCallback(initPreviewsCallback, [])

  const error = pageError || globalError

  useEffect(() => {
    if (!loaded) {
      init(id)
      initPreviews(id, QUICK_VIEW)
    }
  }, [loaded])

  return (
    <>
      <Header />
      <PreviewModal />
      <Loading open={loading} />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => init(id)}
        />
        {!error && !loading && (
          <>
            {view === BASIC_VIEW && (
              <>
                <BoxGoToPreview />
                <BoxOnScreen />
              </>
            )}

            {(view === QUICK_VIEW || view === FULL_VIEW) && (
              <QuickFullPreview viewType={view} />
            )}
          </>
        )}
      </PageContainer>
    </>
  )
}

export default EmailMessagePreview
